<h1 mat-dialog-title>{{'home.login.passwordRecovery' | translate}}</h1>

<div style="padding-left: 5%;">
    <form [formGroup]="form">
        <mat-form-field appearance="standard" color="standart">
            <mat-label>{{"password.recovery.customerNumber" | translate }}</mat-label>
            <input matInput formControlName="customerNumber">
        </mat-form-field>

        <mat-form-field appearance="standard" color="standart">
            <mat-label>{{"password.recovery.username" | translate }}</mat-label>
            <input matInput formControlName="username">
        </mat-form-field>
    </form>
    <div class="validation-error" *ngIf="showError">
        <label>{{"password.recovery.invalid" | translate}}</label>
    </div>
    <div class="d-flex">
        <button mat-flat-button color="primary" class="action-button" (click)="recovery()" style="width: 180px">{{"password.recovery.submit" | translate}}</button>
    </div>
</div>
